import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["fileSelect", "docGroup", "preview"]

  connect() {
    this.showSelectedFile()
  }

  selectFile() {
    this.showSelectedFile()
  }

  showSelectedFile() {
    const selectedId = this.fileSelectTarget.value

    this.docGroupTargets.forEach(group => {
      if (group.dataset.sourceDocId === selectedId) {
        group.classList.remove("hidden")
      } else {
        group.classList.add("hidden")
      }
    })

    // Auto-select first document in the visible group for preview
    const visibleGroup = this.docGroupTargets.find(g => g.dataset.sourceDocId === selectedId)
    if (visibleGroup) {
      const firstDoc = visibleGroup.querySelector("[data-doc-url]")
      if (firstDoc) {
        this.showPreview(firstDoc.dataset.docUrl)
      }
    }
  }

  injectSelectedFile(event) {
    const form = event.currentTarget
    const selectedId = this.fileSelectTarget.value
    if (selectedId) {
      const input = document.createElement('input')
      input.type = 'hidden'
      input.name = 'selected_source_doc_id'
      input.value = selectedId
      form.appendChild(input)
    }
  }

  selectDocument(event) {
    // Don't update preview when clicking form buttons (Add/Remove)
    if (event.target.closest("button[type='submit'], input[type='submit']")) return

    const url = event.currentTarget.dataset.docUrl
    if (url) {
      this.showPreview(url)
    }
  }

  showPreview(url) {
    if (this.hasPreviewTarget) {
      this.previewTarget.src = url
    }
  }
}
